(function () {
  'use strict';

  if (customElements.get('kuoca-card-carousel')) return;

  class KuocaCardCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.carouselReady === 'true') return;

      this.track = this.querySelector('.kuoca-card-carousel__track');
      this.indicators = Array.prototype.slice.call(
        this.querySelectorAll('.kuoca-card-carousel__indicator i'),
      );
      if (!this.track || this.indicators.length < 2) return;

      this.dataset.carouselReady = 'true';
      this.activeIndex = 0;
      this.frame = 0;
      this.didDrag = false;
      this.pointerStartX = null;
      this.suppressClickUntil = 0;

      this.track.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
      this.track.addEventListener('pointerdown', this.handlePointerDown.bind(this), { passive: true });
      this.track.addEventListener('pointermove', this.handlePointerMove.bind(this), { passive: true });
      this.track.addEventListener('pointerup', this.handlePointerEnd.bind(this), { passive: true });
      this.track.addEventListener('pointercancel', this.handlePointerEnd.bind(this), { passive: true });
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleScroll() {
      this.suppressClickUntil = Date.now() + 200;
      if (this.frame) return;

      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (!this.track.clientWidth) return;
        this.updateIndicator(Math.round(this.track.scrollLeft / this.track.clientWidth));
      });
    }

    handlePointerDown(event) {
      this.pointerStartX = event.clientX;
      this.didDrag = false;
    }

    handlePointerMove(event) {
      if (this.pointerStartX === null) return;
      if (Math.abs(event.clientX - this.pointerStartX) > 8) this.didDrag = true;
    }

    handlePointerEnd() {
      if (this.didDrag) this.suppressClickUntil = Date.now() + 200;
      this.pointerStartX = null;
      this.didDrag = false;
    }

    handleClick(event) {
      if (!this.didDrag && Date.now() >= this.suppressClickUntil) return;
      event.preventDefault();
      event.stopPropagation();
    }

    updateIndicator(index) {
      var nextIndex = Math.max(0, Math.min(index, this.indicators.length - 1));
      if (nextIndex === this.activeIndex) return;
      this.activeIndex = nextIndex;
      this.indicators.forEach(function (indicator, indicatorIndex) {
        indicator.classList.toggle('is-active', indicatorIndex === nextIndex);
      });
    }
  }

  customElements.define('kuoca-card-carousel', KuocaCardCarousel);
})();
